import { render } from "./UserCard.vue?vue&type=template&id=340fd53f&scoped=true&ts=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=340fd53f&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340fd53f"]])

export default __exports__